const productTabs = document.querySelectorAll('.product-tabs .tab')
const productContent = [...document.querySelectorAll('.product_tab_content')]

productTabs.forEach((item, index) => {
    item.addEventListener('click', function () {
        removeClassActive(productTabs)
        removeClassActive(productContent)

        this.classList.add('active')
        let currrentContent = productContent.find((item, i) => i === index)
        currrentContent && currrentContent.classList.add('active')  
    })
})

function removeClassActive(arr) {
    for (let item of arr) item.classList.remove('active')
}